import styled from 'styled-components'

export const Container = styled.div`
  padding-top: ${props => props.paddingTop};
  padding-bottom: ${props => props.paddingBottom};
`
